import React, { useState } from "react";
import { TextValidator } from "react-material-ui-form-validator";
import { textMasks } from "../../../../utils/textMasks";
import EligibilityInputCheckbox from "../EligibilityInputCheckbox/EligibilityInputCheckbox"
import MaskedInput from "react-text-mask";
import styles from "../../AccountVerificationForm/AccountVerificationForm.module.css"

function TextMaskCustom(props) {
  const { inputRef, masktype, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={textMasks(masktype)}
      placeholderChar={"\u2000"}
      keepCharPositions={false}
      guide
    />
  );
}

export default function EligibilityInputArea(props) {
  const {
    question,
    handlerInputChange,
    value,
    extraValues,
    disabled
  } = props;

  const [checkboxAnswers, setCheckboxAnswers] = useState(extraValues);
  const childRef = React.createRef();

  const handlerInputChangeValue = (e) => {
    handlerInputChange(e.target.value, question, checkboxAnswers);
  }

  const handlerInputCheckboxChange = (checkboxValue) => {
    setCheckboxAnswers(checkboxValue);
    handlerInputChange(value, question, checkboxValue);
  }

  return (
    <React.Fragment>
      <TextValidator
        style={question.field.checkboxQuestion ? { marginBottom: 5 } : {}}
        ref={childRef}
        label={
          question.required ? (
            <div>
              {question.label}
              <span
                style={{
                  color: "red",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >*</span>
              {" "}
              {question.helpText &&
                <div className={ styles.tooltip}> ?
                  <span className={ styles.tooltipText} >{question.helpText}</span>
                </div>
              }
            </div>
          ) : (
            <div>
                {question.label}
                <span style={{ fontSize: "16px"}} > {" "} </span>
                {question.helpText &&
                  <div className={ styles.tooltip}> ?
                    <span className={ styles.tooltipText} >{question.helpText}</span>
                  </div>
                }
            </div>
          )
        }
        value={value}
        disabled={disabled}
        id={question.id}
        name={question.name}
        placeholder={question.placeholder}
        validators={question.field.validators}
        errorMessages={question.field.errorMessages}
        onChange={(e) => {
          e.preventDefault();
          handlerInputChangeValue(e);
        }}
        fullWidth
        multiline
        rowsMax={5}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={
          (question.field.maskType || question.id === "phoneNumber")
            ? {
              inputComponent: TextMaskCustom,
              disableUnderline: true,
              inputProps: {
                masktype: question.id === "phoneNumber" ? "phone" : question.id === "homeSquareFeet" ? "homeSqft" : question.field.maskType
              }
            }
            : { disableUnderline: true }
        }
      />
      {question.field.checkboxQuestion &&
        <EligibilityInputCheckbox
          value={checkboxAnswers}
          question={question}
          handlerInputCheckboxChange={handlerInputCheckboxChange}
        />
      }
    </React.Fragment>
  );
}
